import React,{useRef,useState,useEffect } from 'react';
import Sidebar from '../../Components/sidebar/Sidebar';
import Topbar from '../../Components/topbar/Topbar';
import Footer from '../../Components/Footer/Footer';
import {AiOutlineMail,AiOutlineStar,AiOutlineExclamationCircle,AiFillTag} from 'react-icons/ai'
import {FiSend,FiFolder,FiSearch} from 'react-icons/fi'
import {BiPencil,BiTrashAlt} from 'react-icons/bi'
import {GrAttachment} from 'react-icons/gr'
import {ImAttachment} from 'react-icons/im'
import './email.css';
import './responsive.css';
import dataitems from './email.json'

function Email(props) {
  const tog = useRef(null)
  const ov = useRef(null)
  const [isChecked,setChecked] = useState(false)
  useEffect(() => {

  document.querySelector('.form-input').addEventListener('input', (e)=>{
    if(e.target.checked === true){
 setChecked(true)
 }
  else{
    setChecked(false)
  }
  })
 console.log(isChecked)
  }, [isChecked]); 
    return (
        <>
        <div className="wrapper">
            <Sidebar myref={tog} myref2={ov}/>
            <div className="page-wrapper">
              <div className="over" ref={ov}></div>
                <Topbar title="Dashboard"  myref2={ov} myref={tog} />
                <div className="page-content">
                  <div className="email">
                    <div className="email-sidebar">
                      <div className="head">
                        <a className="butn" href>compose</a>
                      </div>
                      
                      <div className="body">
                        <ul className="actions">
                          <li>
                            <a href className="list-item-group active" id="inbox">
                            <span className="icon"><AiOutlineMail/></span>
                            <span className="text">inbox</span>
                            <span className="badge">3</span>
                            </a>
                          </li>
                          <li>
                            <a href className="list-item-group" id="send">
                            <span className="icon"><FiSend/></span>
                            <span className='text'>send</span>
                            <span className="badge">3</span>
                            </a>
                          </li>
                          <li>
                            <a href className="list-item-group" id="draft">
                            <span className="icon"><BiPencil/></span>
                            <span className="text">draft</span>
                            <span className="badge">3</span>
                            </a>
                          </li>
                          <li>
                            <a href className="list-item-group" id="starred">
                            <span className="icon"><AiOutlineStar/></span>
                            <span className="text">starred</span>
                            <span className="badge">3</span>
                            </a>
                          </li>
                          <li>
                            <a href className="list-item-group" id="spam">
                            <span className="icon"><AiOutlineExclamationCircle/></span>
                            <span className="text">spam</span>
                            <span className="badge">3</span>
                            </a>
                          </li>
                          <li>
                            <a href className="list-item-group" id="trash">
                            <span className='icon'><BiTrashAlt/></span>
                            <span className="text">trash</span>
                            <span className="badge">3</span>
                            </a>
                          </li>
                        </ul>
                        
                        <h3>labels</h3>
                        <ul className="labels">
                           <li>personal</li>
                           <li>company</li>
                           <li>important</li>
                           <li>private</li>
                        </ul>
                      </div>
                    </div>
                    <div className="email-body">
                      <div className="search">
                        <form>
                          <span><FiSearch/></span>
                          <input type='search' placeholder="Search email"/>
                        </form>
                      </div>
                      <div className="email-check">
                       <div class="form-check">
                         
                           <input type="checkbox" className="form-input" name="" id="" value="checkedValue"  />
                           <label class="form-check-label">select all</label>
                             
                       </div>
                         <div className="options" style={isChecked === true ?{display:'block'}:{display:'none'}}>
                             <span><FiFolder/></span> 
                             <span><AiFillTag/></span> 
                             <span><AiOutlineMail/></span> 
                             <span><BiTrashAlt/></span> 
                            </div> 
                      </div>
                      <div className="email-users">
                        {dataitems.filter( i=> i.catagorey === "inbox").map( i => (
                           <div className="item" key={i.id}>
                            <div className="main-info">
                              <div className="user-info">
                              <img src={i.img} alt="user"/>
                              <div className="text">
                                  <h3>{i.name}</h3>
                                  <p>{i.title}</p>
                                </div>
                              </div>
                               <div className="other-info">
                                 <span  className="attach" style={i.attach === 'null'?{display:'none'}:{display:'block'}}>
                                   <ImAttachment color="#6e6b7b"/>
                                 </span>
                                 <span className={i.status + " status"}>
                                            
                                 </span>
                                 <span>{i.id < 2 ? i.time:i.date}</span>
                             </div>
                            </div>
                              <div className="bottom-info">
                                <div className="left">
                                 <input type="checkbox" className="form-input" name="" id="" value="checkedValue"  />
                                 <span><AiOutlineStar /></span>
                                 </div>
                                 
                                <p className="right text-email">{i.body}</p>
                                
                              </div>
                             
                             </div>
           
                        ))
                        
                        
                        }
                      </div>
                    </div>
                  </div>
                 </div>
                <Footer/>
            </div>
         </div> 
        </>
    );
}

export default Email;